// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Icons
import PeopleIcon from "@mui/icons-material/People";
import LockIcon from "@mui/icons-material/Lock";
import ReplayIcon from "@mui/icons-material/Replay";
import AssessmentIcon from "@mui/icons-material/Assessment";

// Setup menu items
const setupMenus = [
  {
    title: "Create Temporary Stop",
    description: "Create a new temporary stop for staff",
    icon: <PeopleIcon fontSize="large" color="primary" />,
    route: "/variations/temporarystoppage/CreateTemporaryStoppage",
  },
  {
    title: "Manage Temporary Stops",
    description: "View and manage existing temporary stops",
    icon: <LockIcon fontSize="large" color="primary" />,
    route: "/variations/temporarystoppage/ManageTemporaryStorage",
  },
  {
    title: "Resume Staff",
    description: "Resume staff after temporary stoppage",
    icon: <ReplayIcon fontSize="large" color="primary" />,
    route: "/variations/temporarystoppage/TemporaryStoppagesList",
  },
  // {
  //   title: "Reports",
  //   description: "Generate temporary stoppage reports",
  //   icon: <AssessmentIcon fontSize="large" color="primary" />,
  //   route: "/setup/grade-levels",
  // },
];

function SetupMenu() {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          {setupMenus.map((item, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                sx={{
                  height: "100%",
                  minHeight: 200,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  borderRadius: 4,
                  boxShadow: 3,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px) scale(1.03)",
                    boxShadow: 8,
                  },
                  background: "linear-gradient(135deg, #ffffff, #f9f9ff)",
                }}
              >
                <CardActionArea
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    p: 2,
                  }}
                  onClick={() => navigate(item.route)}
                >
                  {item.icon}
                  <CardContent>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      {item.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {item.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SetupMenu;
